// Libelle d'une banque dans les rapports (2026-10-12) : "N° - nom", ou N° =
// Bank.seq, le meme numero que le "REF" imprime sur les fiches du POS (ex. 4 ->
// REF 04-04). Sans N° connu (vieille reponse backend), juste le nom.
export const bankLabel = (seq, name) => (seq != null && seq !== '' ? `${seq} - ${name ?? ''}` : (name ?? ''));
